import { useNavigate, useParams } from "react-router";
import Screen from "../../components/Screen";
import { useEffect, useState } from "react";
import { routes } from "../../utils/routeHelper";
import { AccountTabTypeEnum } from "../../types/AccountTabTypeEnum";
import { DeviceTabTypeEnum } from "../../types/DeviceTabTypeEnum";
import { useStore } from "../../store/store";
import { CoreProductTypeEnum } from "@gf-core/widgets/types/CoreProductTypeEnum";
import { CoreAppStoreModel } from "@gf-core/widgets/types/CoreAppStoreModel";
import CoreAppStore from "@gf-core/widgets/widgets/CoreAppStore";
import { CoreAppStoreRoutesEnum } from "@gf-core/widgets/types/CoreAppStoreRoutesEnum";

export default function Store() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [pId, setProductId] = useState<string | undefined>(undefined);
  const setActiveMenuId = useStore.useSetActiveMenuId();

  useEffect(() => {
    setActiveMenuId(undefined);
  }, []);

  const config = [
    {
      kind: "icon",
      withSwiper: false,
      title: "Connectors",
      filters: {
        productType: [CoreProductTypeEnum.CONNECTORS],
      },
    },
    {
      kind: "card",
      withSwiper: false,
      title: "Connectors",
      filters: {
        productType: [CoreProductTypeEnum.CONNECTORS],
      },
    },
    {
      kind: "tile",
      withSwiper: false,
      title: "Connectors",
      filters: {
        productType: [CoreProductTypeEnum.CONNECTORS],
      },
    },
  ] as CoreAppStoreModel[];

  useEffect(() => {
    setProductId(productId);
  }, [productId]);

  return (
    <Screen isAnimated>
      <CoreAppStore
        appStoreConfiguration={config}
        isModal={false}
        onConfigureLater={(accountId: string) => {
          navigate(routes.account.set(accountId, AccountTabTypeEnum.Wallet));
        }}
        onCompleted={(
          accountId: string,
          installationId: string,
          deviceId: string,
        ) => {
          navigate(
            routes.device.set(
              accountId,
              installationId,
              deviceId,
              DeviceTabTypeEnum.Overview,
              "core-device-widget",
            ),
          );
        }}
      />

      <CoreAppStore
        appStoreConfiguration={config}
        show={Boolean(pId)}
        productId={pId}
        starterScreen={CoreAppStoreRoutesEnum.PRODUCT_DETAIL_SCREEN}
        onConfigureLater={(accountId: string) => {
          navigate(routes.account.set(accountId, AccountTabTypeEnum.Wallet));
        }}
        onCompleted={(
          accountId: string,
          installationId: string,
          deviceId: string,
        ) => {
          navigate(
            routes.device.set(
              accountId,
              installationId,
              deviceId,
              DeviceTabTypeEnum.Overview,
              "core-device-widget",
            ),
          );
        }}
        onClose={() => setProductId(undefined)}
      />
    </Screen>
  );
}
